import React, {useState,  useEffect } from 'react';
import DeckGL from 'deck.gl';


import { renderLayers } from "./RenderLayers";

// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    latitude: 36.1953031518542,
    longitude: -115.4239545432974,
    bearing: 0,
    pitch: 0,
    zoom: 6
};



function Map() {
    const [data, setData] = useState(null)
    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE);


    
    return (
        <div>
            <DeckGL
                initialViewState={viwState}
                controller={true}
                layers={renderLayers({ data })}
                onViewStateChange={(v)=>{ console.log(v.viewState) }}
            >
            </DeckGL>
            <div id="fieldset">
                <ul>
                    <li className="urban">Urban and built-up</li>
                </ul>
            </div>
            
            <div className="attribution">
                <a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>
            </div>
        </div>
    );
}


export default Map;